import React from 'react';
import '../ChatApp.css';

const getRoundScoreLabel = (score) => {
  if (score === null || score === undefined) {
    return '';
  }

  if (typeof score === 'number' || typeof score === 'string') {
    return String(score);
  }

  if (typeof score === 'object') {
    const value = score.score ?? score.points ?? score.value ?? score.total;
    return value === null || value === undefined ? '' : String(value);
  }

  return String(score);
};

const ScoreBoard = ({ players = {}, finalCost = null, onClose = null }) => {
  const sortedPlayers = Object.entries(players || {})
    .map(([name, data]) => ({
      name,
      ...data
    }))
    .sort((a, b) => b.total - a.total);

  const formattedCost = typeof finalCost === 'number' && Number.isFinite(finalCost)
    ? finalCost.toFixed(2)
    : null;

  return (
    <div className="player-scoreboard">
      <div className="player-header" style={{ justifyContent: 'center' }}>
        <span>🏆 Leader Board 🏆</span>
      </div>
      {sortedPlayers.map((player, index) => (
        <div key={player.name} className="player-row">
          <div className="player-header">
            <span className="player-name">#{index + 1} {player.name}</span>
            <span className="player-total">{player.total}</span>
          </div>
          <div className="player-rounds">
            {Array.isArray(player.rounds) ? player.rounds.map((score, roundIndex) => {
              const scoreLabel = getRoundScoreLabel(score);

              return (
                <span key={roundIndex} className="round-score-label">
                  R{roundIndex + 1}: <span className="round-score-value">{scoreLabel}</span>
                </span>
              );
            }) : null}
          </div>
        </div>
      ))}
      {(formattedCost !== null || onClose) && (
        <div className="player-scoreboard-footer">
          {formattedCost !== null && (
            <div className="player-scoreboard-cost">
              <span className="player-scoreboard-cost-label">Final Cost</span>
              <span className="player-scoreboard-cost-value">${formattedCost}</span>
            </div>
          )}
          {onClose && (
            <button
              type="button"
              className="btn player-scoreboard-close"
              onClick={onClose}
            >
              Close
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default ScoreBoard;
